import axios from "axios";
import { API } from "./catalogueApi";

export const PAY_PATH = /^\/(checkout|pay)(\/|$)/;
const VID = "rst_asst_vid";
const KEY = "rst_asst";
const client = axios.create({ baseURL: `${API}/assistant`, withCredentials: true });
client.interceptors.request.use((cfg) => {  // same customer CSRF header as the cart client
  if (!["get", "head", "options"].includes((cfg.method || "get").toLowerCase())) {
    const m = document.cookie.match(/(?:^|; )rst_customer_csrf=([^;]*)/);
    if (m) cfg.headers = { ...(cfg.headers || {}), "X-CSRF-Token": decodeURIComponent(m[1]) };
  }
  return cfg;
});

export function visitorId() {
  let v = localStorage.getItem(VID);
  if (!v) { v = `v${Math.random().toString(36).slice(2)}${Date.now().toString(36)}`; localStorage.setItem(VID, v); }
  return v;
}

const post = (path, body) => client.post(path, body).then((r) => r.data)
  .catch((e) => { throw new Error(e?.response?.data?.detail || "Something went wrong. Please try again."); });

export const assistantConfig = () => client.get("/config").then((r) => r.data);
export const assistantChat = (conversation_id, message, context) => post("/chat", { conversation_id, visitor_id: visitorId(), message, context });
export const assistantExplain = (conversation_id) => post("/explain", { conversation_id, visitor_id: visitorId() });  // T72b: second phase
// T76a: streamed turn (server-sent events over POST). onEvent gets {type: meta|text|cards|done|error, ...}
export async function assistantStream(conversation_id, message, context, onEvent) {
  const m = document.cookie.match(/(?:^|; )rst_customer_csrf=([^;]*)/);
  const res = await fetch(`${API}/assistant/stream`, {
    method: "POST", credentials: "include",
    headers: { "Content-Type": "application/json", ...(m ? { "X-CSRF-Token": decodeURIComponent(m[1]) } : {}) },
    body: JSON.stringify({ conversation_id, visitor_id: visitorId(), message, context }),
  });
  if (!res.ok || !res.body) {
    let d = null;
    try { d = (await res.json()).detail; } catch { /* not JSON */ }
    throw new Error(typeof d === "string" ? d : "Something went wrong. Please try again.");
  }
  const reader = res.body.getReader(), dec = new TextDecoder();
  let buf = "";
  for (;;) {
    const { value, done } = await reader.read();
    if (done) break;
    buf += dec.decode(value, { stream: true });
    let k;
    while ((k = buf.indexOf("\n\n")) >= 0) {
      const data = buf.slice(0, k).split("\n").filter((l) => l.startsWith("data:")).map((l) => l.slice(5).trim()).join("");
      buf = buf.slice(k + 2);
      if (data) onEvent(JSON.parse(data));
    }
  }
}
export const assistantEvent = (conversation_id, product_id, kind) => conversation_id && post("/event", { conversation_id, product_id, kind }).catch(() => {});

// in-session conversation (kept across page navigation, cleared when the tab closes)
export const loadChat = () => { try { return JSON.parse(sessionStorage.getItem(KEY)) || {}; } catch { return {}; } };
export const saveChat = (s) => sessionStorage.setItem(KEY, JSON.stringify(s));
export const openAssistant = (context) => {
  window.__rstAsstPending = context || {};  // picked up on mount if the assistant isn't listening yet
  window.dispatchEvent(new CustomEvent("assistant-open", { detail: context || {} }));
};
